module.exports = __webpack_public_path__ + "static/BT-desktop-20-973549813f4c5f568d801c71e55f470c.jpg";